export default __webpack_public_path__ + "static/media/fit in deutsch final A2.26445c5f.jpg";